import { render, staticRenderFns } from "./SelectTranslationDialog.vue?vue&type=template&id=0e8fd9da&scoped=true&"
import script from "./SelectTranslationDialog.vue?vue&type=script&lang=js&"
export * from "./SelectTranslationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8fd9da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCardText,VCombobox})
